<template>
    <transition name="fade">
        <div v-if="show" class="risk-panel">
            <div class="risk-wrapper d-flex row p-4 mb-4 align-items-center">
                <h3 class="w-auto p-0 m-0">Risk Assessments</h3>
                <a :href="riskAssesmentLink" class="text-black w-auto ml-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-fullscreen" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344 0a.5.5 0 0 1 .707 0l4.096 4.096V11.5a.5.5 0 1 1 1 0v3.975a.5.5 0 0 1-.5.5H11.5a.5.5 0 0 1 0-1h2.768l-4.096-4.096a.5.5 0 0 1 0-.707m0-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707m-4.344 0a.5.5 0 0 1-.707 0L1.025 1.732V4.5a.5.5 0 0 1-1 0V.525a.5.5 0 0 1 .5-.5H4.5a.5.5 0 0 1 0 1H1.732l4.096 4.096a.5.5 0 0 1 0 .707"/>
                    </svg>
                </a>
                <actions-list
                    :key="isEditing"
                    v-if="!isEditing"
                    :actions="allActions"
                    :editable="false"
                    @remove-action="removeAction"
                    @remove-hazard="removeHazard"
                    @remove-control="removeControl"a
                />
                <actions-list v-else
                    :key="isEditing"
                    :actions="selected.actions"
                    :editable="isEditing"
                    @remove-action="removeAction"
                    @remove-hazard="removeHazard"
                    @remove-control="removeControl"
                />

            </div>
            <div class="p-3" v-if="isEditing">
                <button @click="saveClonedRisk" class="w-100 btn btn-primary mt-4">Save</button>
            </div>

        </div>
    </transition>
</template>

<script>
import ActionsList from './ActionsList.vue'

export default {
    components: {
        ActionsList,
    },
    inject: ['notyf'],
    data() {
        return {
            show: false,
            risks: [],
            selected: null,
            filtered: false,
            loading: true,
            project: null,
            isEditing: false,
        }
    },
    props: {
        markup: null,
        map_url: null,
        isVisible: null,
        isShared: {
            type: Boolean,
            default: false
        },
        readOnlyRisks: null
    },
    methods: {

        fetchRisks() {
            if(this.isShared) return false;
            let endpoint;
            const urlParams = new URLSearchParams(window.location.search);
            const signature = urlParams.get('signature');
            if(signature) {
                endpoint = `/shared/risk?scope=${this.markup}&signature=${signature}`;
            } else {
                endpoint = `/risk?scope=${this.markup}`;
            }
            if (this.markup == null) {
                return;
            }

            this.loading = true;
            axios.get(endpoint)
                .then(response => {
                    console.log("in the callback");
                    this.risks = response.data.data
                    this.loading = false


                    if(isVisible) {
                        this.show = true;
                    }
                })
                .catch(error => {
                    console.log('fetchRisks error', error);
                })
        },
        filter(risk) {
            this.selected = risk;
            this.filtered = true;
        },
        removeAction(index) {
            this.selected.actions.splice(index, 1);
        },
        removeHazard(actionIndex, hazardIndex) {
            this.selected.actions[actionIndex].hazards.splice(hazardIndex, 1);
        },
        removeControl(actionIndex, controlIndex, hazardIndex) {
            console.log({actionIndex, controlIndex});
            console.log(this.selected.actions[actionIndex]);
            this.selected.actions[actionIndex].hazards[hazardIndex].controls.splice(controlIndex, 1);
        },
        saveClonedRisk() {
            const payload = {
                project_name: this.project.name,
                actions: this.selected.actions,
                original_r_id: this.selected.id,
                project_id: this.project.id
            };

            axios.post('/risk-assessment/clone', payload)
                .then(res => {
                    this.fetchRisks();
                    this.notyf.success('Cloned and saved!');
                    this.isEditing = false

                })
                .catch(err => {
                    console.log('saveClonedRisk', err);
                    this.notyf.error('Failed to save clone.');
                })
        }
    },
    mounted () {
        if(!this.isShared) {
            this.fetchRisks();
        }

        document.addEventListener('cm:toggle-risk-sidebar-after-selection', (event) => {
            this.show = true;
            this.selected = event.detail.risk;
            this.project = event.detail.project;
            this.isEditing = true;
        });

        document.addEventListener('cm:toggle-risk-sidebar', (event) => {
            this.show = !this.show;
        });


    },

    computed: {
        riskAssesmentLink() {
            if(this.map_url) {
                return `/risk/view/${this.markup}?return_share=${this.map_url}`
            }

            return `/risk/view/${this.markup}`
        },

        allActions() {
            if(!this.isShared) {
                return this.risks.flatMap(risk => risk.actions);
            }
            return this.readOnlyRisks.flatMap(risk => risk.actions);

        }
    },

    watch: {
        show(newValue, oldValue) {
            if (this.show == true) {
                document.querySelector('#mapDiv').style.width = "75%"
            } else {
                document.querySelector('#mapDiv').style.width = ""
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .risk-panel {
        background: #fefefe;
        margin-top: 2.5em;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 25%;
        // height: 100vh;
        h3 {
            color: #010101
        }
        .risk-wrapper {
            max-height: 95vh;
            overflow-y: scroll;
            overflow-x: clip;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
